module.exports = __webpack_public_path__ + "img/entrance-fee-envelope.d728369f.png";